import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ERoleNames, TAppConfig } from '../api-ducks/app-config-duck/types-app-config';

const initialState: TAppConfig = {
  defaultFiscalYearId: '0',
  defaultSemesterId: '0',
  flightedPlans: [],
  isBusinessPersona: false,
  businessPersonaRoleName: ERoleNames.None,
};

const appConfigDuck = createSlice({
  name: 'appConfig',
  initialState,
  reducers: {
    setAppConfig: (state, action: PayloadAction<TAppConfig>) => action.payload,
    clearAppConfig: () => initialState,
  },
});

export const { setAppConfig, clearAppConfig } = appConfigDuck.actions;
export default appConfigDuck.reducer;
